import http from "@/utils/http";
export const queryList = (busName) => {
  return http.get(`/nonlogin/onewebsitehande/queryMoreExpress.htm?busName=${busName}`)
}
